import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 0H30H0ZM30 30H0H30Z",
		fill: "#212121"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.31248 7.0125C7.83748 10.25 12.5 16.25 12.5 16.25V23.75C12.5 24.4375 13.0625 25 13.75 25H16.25C16.9375 25 17.5 24.4375 17.5 23.75V16.25C17.5 16.25 22.15 10.25 24.675 7.0125C25.3125 6.1875 24.725 5 23.6875 5H6.29998C5.26248 5 4.67498 6.1875 5.31248 7.0125Z",
		fill: "currentColor"
	})]
});
export default SvgFilter;
